<template>
  <div v-show="role" class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />
    <div class="flex flex-col justify-center mb-5">
      <h1 class="font-semibold text-2xl text-center my-5">
        Our Evaluation Process
      </h1>
      <p class="leading-6 max-w-5xl">
        We developed a multi-level evaluation process for curating Facebook ads
        and Tiktok ads. Before an ad example makes it to Adbox, we review the
        brand it is associated with:
      </p>
    </div>
    <div class="flex flex-col justify-center mb-5 mx-auto">
      <div class="flex flex-col justify-center pb-5 mx-10 my-2">
        <ul class="list-disc flex flex-col justify-center">
          <li class="py-1">
            <span class="text-base font-medium text-gray-700">
              Fast-growing eCommerce brand?
            </span>
          </li>
          <li class="py-1">
            <span class="text-base font-medium text-gray-700">
              Estimated annual revenue (is it at at least >$1ml?)
            </span>
          </li>
          <li class="py-1">
            <span class="text-base font-medium text-gray-700">
              Traffic volume
            </span>
          </li>
          <li class="py-1">
            <span class="text-base font-medium text-gray-700">
              Ad testing process, and more
            </span>
          </li>
        </ul>
      </div>

      <p class="leading-6 max-w-5xl mt-1">
        If the brand meets our criteria, we add it to our internal brand
        selection, which has around 9800+ brands now and we start analyzing them
        every week to know what's working for them.
      </p>

      <p class="leading-6 max-w-5xl mt-6">
        At the creative level, we look at groups of characteristics: how long
        the ad has been active vs the testing time, and how strong the hook is
        to grab the user's attention, concept, style, visual features, copy,
        etc.
      </p>
      <p class="leading-6 max-w-5xl mt-6">
        Our curation team analyzes more than 10.000 ads per month, and most of
        them do not pass this process, they only handpick and add 100+ ads to
        Adbox every month. Quality over quantity.
      </p>
      <p class="leading-6 max-w-5xl mt-6">
        The ads are not selected by industry, they are selected by the previous
        characteristics, some brands have more winner ads than others, and many
        are just the same creative concepts that we have already in Adbox.
      </p>
      <p class="leading-6 max-w-5xl mt-6">
        Therefore, we upload 100+ in total the first week of the month, there
        might be 5, 10, or 50 for a specific industry, but everything depends on
        the brands. The most popular industries, because brands test many more
        ad creatives, are Fashion and Beauty. But, we have our eyes open for all
        10 industries.
      </p>
      <p class="leading-6 max-w-5xl mt-6">
        All this process takes our team between 230 to 270 hours per month, so
        just taking into account the time investment, if you value your time
        more than $5 per hour, then you are saving more than $1150 every single
        month!
      </p>
    </div>

    <div
      v-if="role === 'free'"
      class="flex flex-col justify-center py-4 lg:py-10"
    >
      <div class="max-w-2xl mx-auto mt-4 flex flex-col px-10">
        <div
          class="inline-flex justify-between py-4 rounded-md border mt-6 p-6 bg-indigo-600 text-white"
        >
          <div class="flex gap-2 items-center">
            <div class="bg-indigo-700 rounded pt-1 pb-2 px-2 mr-2">
              <Icon name="LockOpen" class="w-6 h-6" />
            </div>
            <p class="text-white py-2">
              Want full access to Adbox
              <span class="font-bold">{{ text }}</span
              >?
            </p>
          </div>

          <div class="flex gap-5 ml-10">
            <router-link to="/pricing">
              <Button
                type="submit"
                class="px-5 my-0 py-0 bg-white hover:bg-indigo-400 text-indigo-600 rounded-md"
              >
                Join now
              </Button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderApp from "@/components/Header";
import Button from "@/components/UI/Button";
import Icon from "@/components/UI/Icon";

import { computed } from "vue";
import { useStore } from "vuex";
export default {
  components: { HeaderApp, Button, Icon },
  setup() {
    const store = useStore();

    const role = computed(() => store.state.role);

    return { role };
  },
};
</script>

<style scoped></style>
